import {
  ExtendedBusinessSiteData,
  IAdminAppNotification,
  IBusinessSiteData,
  IClient,
  ICoordinates
} from '@torim-app/types';
import {adminUrlBuilder} from "@app/api/utils";
import {IHelpCenter} from "@torim-app/types";

export class SharedApi {

  static async fetchBusinessData(): Promise<ExtendedBusinessSiteData> {
    const url = adminUrlBuilder({});
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (response.status === 404)
      throw "Business does not exist";
    else if (!response.ok)
      throw "Failed to get business data";

    return await response.json();
  }

  static async fetchProviders(): Promise<Array<Pick<IClient, 'userId' | 'fullName' | 'profileImage'>>> {
    const url = adminUrlBuilder({}, 'providers');
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (response.status === 404)
      throw "Business does not exist";
    else if (!response.ok)
      throw "Failed to get providers";

    return await response.json();
  }

  static async uploadImages(
    body: FormData,
    coords?: ICoordinates
  ): Promise<Array<string>> {
    const queryParams: Record<string, number | string> = {}
    if (coords) {
      const {top, height, left, width} = coords;
      queryParams['coordinates[width]'] = width;
      queryParams['coordinates[top]'] = top;
      queryParams['coordinates[height]'] = height;
      queryParams['coordinates[left]'] = left;
    }
    const url = adminUrlBuilder(queryParams, 'upload-image');
    const response = await fetch(url, {
      method: 'post',
      body: body
    });

    if (!response.ok)
      throw response.statusText;

    return await response.json();
  }

  static async sendWelcomeNotification() {
    const url = adminUrlBuilder({}, 'notifications');
    const response = await fetch(url, {method: 'put',});

    if (!response.ok)
      throw response.statusText;
  }

  static async markNotificationAsRead(notificationId: string) {
    const url = adminUrlBuilder({notificationId}, 'notifications-panel');
    const response = await fetch(url, {method: 'put'});

    if (!response.ok)
      throw response.statusText;
  }

  static async getAllNotifications() {
    const url = adminUrlBuilder({}, 'notifications-panel');
    const response = await fetch(url, {method: 'get'});

    if (!response.ok)
      throw response.statusText;

    return await response.json() as Array<IAdminAppNotification>;
  }

  static async reportAppVersion(appVersion: string): Promise<void> {
    const url = adminUrlBuilder({}, 'report-app-version');
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ appVersion })
    });

    if (!response.ok)
      throw response.statusText;
  }

  static async getAllHelpCenterEntities() {
    const url = adminUrlBuilder({}, 'help-center');
    const response = await fetch(url, {method: 'get'});

    if (!response.ok)
      throw response.statusText;

    return await response.json() as Array<IHelpCenter>;
  }

}
